enum TypeCalculRAR {
	BUDGET_REALISE = 'BR',
	ENGAGE_NON_LIQUIDE = 'ENL',
	REMISE_A_ZERO = 'RAZ',
	RIEN_FAIRE = 'RF',
}

export default TypeCalculRAR;
